
@if (thankYouData | async; as item) {
  <div class="response-container">
    <div class="modal-header">
      <h4 class="modal-title myprofile_modal_header" id="myModalLabel">{{"membership.thankyoulabel" | cxTranslate}}</h4>
      <button (click)="close()" type="button" class="myprofile_modalclose" data-dismiss="modal"
      aria-hidden="true">×</button>
    </div>
    <div class="modal-body" [ngClass]="dataComingFromOrg?'borders':''">
      <!-- <ng-container *ngIf="data.type=='notsure'">
      <p class="myprofile_modalbody_txt" >
        {{item.content}}
      </p>
      <p class="myprofile_modalbody_txt">
        {{item.paragraphcontent}}
      </p>
    </ng-container>     -->
    @if (data.type=='yes' || data.type=='notsure') {
      <p class="myprofile_modalbody_txt">
        {{item.text2}}
      </p>
    }
    @if (data.type=='no') {
      <p class="myprofile_modalbody_txt">
        {{item.content}}
      </p>
      <p class="myprofile_modalbody_txt">
        {{item.paragraphcontent}}
      </p>
    }
    @if (data.type=='account-thank-you') {
      <p class="myprofile_modalbody_txt">
        {{item.title}}
      </p>
    }
    @if (data.type=='request-thank-you') {
      <p class="myprofile_modalbody_txt">
        {{item.title}}
      </p>
    }
  </div>
  <div class="modal-footer">
    <button (click)="close()" type="button" class="btn btn-default myprofile_modalclosebtn"
    data-dismiss="modal">Close</button>
  </div>
</div>
}

